"use strict";
exports.__esModule = true;
var tornado_chart_maker_1 = require("../logic/tornado-chart-maker");
var tornado_logic_1 = require("../logic/tornado-logic");
angular.module('smartorg.r6.acts.tornado').directive('tornadoChart', [function () {
        return {
            restrict: 'E',
            template: require('../../template/tornado.html'),
            scope: {
                menu: '='
            },
            link: function (scope) {
                var showTornado = function (args, isINAV) {
                    if (isINAV === void 0) { isINAV = false; }
                    scope.actionMenuItem = args.actionMenuItem;
                    var portfolioName = args.treeName;
                    scope.inputData = args.config.data.inputData.TornadoDistOutputs;
                    scope.maxBars = args.config.data.maxBars;
                    scope.nodeName = args.config.data.nodeName;
                    scope.decimals = 2;
                    scope.timestampMode = 'lastRecalc';
                    scope.isINAV = isINAV;
                    if (localStorage.getItem('PortfolioConfig') &&
                        portfolioName in JSON.parse(localStorage.getItem('PortfolioConfig'))) {
                        var portfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'))[portfolioName];
                        scope.showTable = portfolioConfig['chart']['showTable'] != "false";
                        scope.decimals = portfolioConfig['chart']['decimals'];
                        scope.showTooltip = portfolioConfig['chart']['showTooltip'] != "false";
                        scope.showChartExplanation = portfolioConfig['chart']['showChartExplanation'] != "false";
                        if (portfolioConfig['timestamp']) {
                            scope.timestampMode = portfolioConfig['timestamp']['timestampMode'];
                        }
                    }
                    else if (args.config.data.settings) {
                        scope.showTable = args.config.data.settings.showTable != "false";
                        scope.decimals = args.config.data.settings.decimals;
                        scope.showTooltip = args.config.data.settings.showTooltip != "false";
                        scope.showChartExplanation = args.config.data.settings.showChartExplanation != "false";
                        scope.timestampMode = args.config.data.settings.timestampMode || 'lastRecalc';
                    }
                    if (scope.decimals == "Default") {
                        if (args.config.data.settings.defaultPrecision) {
                            scope.decimals = args.config.data.settings.defaultPrecision;
                        }
                    }
                    scope.timestamp = scope.timestampMode === 'lastRecalc' ? args.nodeLastRecalc : null;
                    if (scope.showTableOnReload &&
                        (scope.actionMenuItem == scope.actionMenuItemOnReload)) {
                        scope.showTable = scope.showTableOnReload;
                    }
                    if (args.config.data.shadowInputData) {
                        scope.shadowInputData = args.config.data.shadowInputData.TornadoDistOutputs;
                        scope.shadowNodeName = args.config.data.shadowNodeName;
                    }
                    else {
                        scope.shadowInputData = undefined;
                        scope.shadowNodeName = null;
                    }
                    var index = 0;
                    if (scope.selectedInputDataOnReload &&
                        (scope.actionMenuItem == scope.actionMenuItemOnReload)) {
                        for (var i = 0; i < scope.inputData.length; i++) {
                            if (scope.selectedInputDataOnReload.Display == scope.inputData[i].Display) {
                                index = i;
                                break;
                            }
                        }
                    }
                    scope.selectedInputData = scope.inputData[index];
                    scope.selectedShadowInputData = (!scope.shadowInputData) ? null : scope.shadowInputData[index];
                    scope.drawTornadoGraph();
                    scope.appStructure = args.config.data.appStructure;
                    scope.dataStructure = args.config.data.dataStructure;
                    scope.firstFactorActionNameItem = new tornado_logic_1["default"]().getFirstFactorActionNameFromInputs(scope.appStructure, scope.dataStructure, scope.selectedInputData.Table[0].Factor);
                    scope.firstFactorActionName = scope.firstFactorActionNameItem.Display;
                    scope.firstFactorActionID = scope.firstFactorActionNameItem.ID;
                    scope.gotoInput = function () {
                        scope.$emit("workbench:redirect", {
                            menu: scope.firstFactorActionID
                        });
                    };
                    scope.currentTornadoDepth = new tornado_logic_1["default"]().getCurrentTornadoDepth(scope.appStructure);
                    scope.menu = menu();
                    setTimeout(function () {
                        scope.$apply();
                    }, 0);
                };
                scope.$on('command:TORNADODIST', function (event, args) {
                    showTornado(args);
                });
                scope.$on('command:TORNADO_ROLLUP', function (event, args) {
                    showTornado(args);
                });
                scope.$on('command:TORNADODIST_INAV', function (event, args) {
                    showTornado(args, true);
                });
                scope.drawTornadoGraph = function () {
                    var chartMaker = new tornado_chart_maker_1["default"](scope.selectedInputData, scope.selectedShadowInputData, scope.shadowNodeName, scope.nodeName, scope.maxBars, scope.showTooltip, scope.decimals, scope.timestamp);
                    chartMaker.plot();
                    scope.displayTable = chartMaker.makeTableData(scope.decimals);
                };
                scope.selectNewData = function (selectedInputData) {
                    scope.actionMenuItemOnReload = angular.copy(scope.actionMenuItem);
                    scope.selectedInputDataOnReload = angular.copy(selectedInputData);
                    if (scope.shadowInputData) {
                        for (var i = 0; i < scope.shadowInputData.length; i++) {
                            if (scope.shadowInputData[i].Display == selectedInputData.Display) {
                                scope.selectedShadowInputData = scope.shadowInputData[i];
                            }
                        }
                    }
                    scope.drawTornadoGraph();
                };
                scope.exportCsv = function (EU) {
                    if (EU === void 0) { EU = false; }
                    var chartMaker = new tornado_chart_maker_1["default"](scope.selectedInputData, scope.selectedShadowInputData, scope.shadowNodeName, scope.nodeName, scope.maxBars, scope.showTooltip, scope.decimals, scope.timestamp);
                    var csv = chartMaker.toCsv();
                    if (EU) {
                        csv = csv.replace(/,/g, ';');
                        csv = csv.replace(/\./g, ',');
                    }
                    var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
                    var currentDate = chartMaker.getDate();
                    var filename = "TornadoChart_" + scope.nodeName + "_" + currentDate + ".csv";
                    saveAs(blob, filename);
                };
                scope.exportCharts = function () {
                    var exporter = new smartorg.r6.lib.ChartExporter("tornadoChart", "svg-canvas");
                    var title = scope.actionMenuItem + " for " +
                        scope.nodeName;
                    exporter.exportChart(title, true);
                };
                function menu() {
                    return [
                        {
                            'name': 'Display',
                            'items': [{
                                    'name': scope.showTable ? 'Hide Table' : 'Show Table',
                                    'toggle': scope.showTable ? 'Show Table' : 'Hide Table',
                                    'callback': function () {
                                        scope.showTable = !scope.showTable;
                                        scope.showTableOnReload = angular.copy(scope.showTable);
                                        scope.actionMenuItemOnReload = angular.copy(scope.actionMenuItem);
                                    }
                                }]
                        }, {
                            'name': 'Export',
                            'items': [{
                                    'name': 'Chart',
                                    'callback': function () {
                                        scope.exportCharts();
                                    }
                                }, {
                                    'name': 'Table',
                                    'callback': function () {
                                        scope.exportCsv();
                                    }
                                }, {
                                    'name': 'Table EU',
                                    'callback': function () {
                                        scope.exportCsv(true);
                                    }
                                }]
                        }
                    ];
                }
            }
        };
    }]);
//# sourceMappingURL=tornado-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/tornado/app/js/plumbing/tornado-directive.js